import {Modal} from '@mantine/core';
import type {Heading} from '../../usecase/useCompanyDetailContents';
import {ModalContent} from './ModalContent';

export const TableOfContentsModal = ({
  headerContents,
  hasReports,
  companyID,
  isOpen,
  onClose,
}: {
  headerContents: Heading[];
  hasReports: boolean;
  companyID: number;
  isOpen: boolean;
  onClose: () => void;
}) => {
  return (
    <Modal
      opened={isOpen}
      onClose={onClose}
      withCloseButton={false}
      centered
      styles={{
        root: {
          borderRadius: 20,
        },
      }}
    >
      <ModalContent
        headerContents={headerContents}
        hasReports={hasReports}
        companyID={companyID}
        onClose={onClose}
      />
    </Modal>
  );
};
